<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Configure dataset</h1>

                    <a :href="`/#/admin/integrations/pipelines/details/${tid}/${id}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <button @click="handleCreateDatasetCommandV1" class="btn btn-primary">Create a new dataset</button>
            <br /><br />
            <strong>or use existing one</strong>
            <br /><br />
            <button v-for="d in datasets" @click="handleAttachDatasetCommandV1(d.DatasetId)" class="btn btn-primary">{{d.Name}}</button>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineDatasetPage } from '@Integrations/Pipelines/pages-core'

    document.title = "Configure dataset"

    const tid = useOrganizationUnitId()
    const id = useId()
    const { useCurrentUserQuery, usePipelineDetailsQuery, useDatasetsOfOrganizationQuery, useCreateDatasetCommand, useAttachDatasetCommand } = useAdminConfigurePipelineDatasetPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const datasetId = computed(() => modelPipelineDetailsQueryV1.value?.DatasetId)
    const ownedBy = computed(() => modelPipelineDetailsQueryV1.value?.OwnedBy)
    const name = computed(() => modelPipelineDetailsQueryV1.value?.Name)

    const { runDatasetsOfOrganizationQueryV1, modelDatasetsOfOrganizationQueryV1 } = useDatasetsOfOrganizationQuery(tid)
    const datasets = computed(() => modelDatasetsOfOrganizationQueryV1.value?.Datasets)

    const { invokeCreateDatasetCommandV1, succeedCreateDatasetCommandV1 } = useCreateDatasetCommand(null, tid, userId, name)

    const { invokeAttachDatasetCommandV1, succeedAttachDatasetCommandV1 } = useAttachDatasetCommand(id, tid, userId)

    watch([succeedCreateDatasetCommandV1, succeedAttachDatasetCommandV1], (succeed) => {
        if (succeed) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
        runDatasetsOfOrganizationQueryV1()
    })

    function handleCreateDatasetCommandV1() {
        invokeCreateDatasetCommandV1({
            Id: datasetId,
            Name: `Dataset for ${name.value}`,
            OwnedBy: ownedBy.value
        })
    }

    function handleAttachDatasetCommandV1(datasetId) {
        invokeAttachDatasetCommandV1({
            DatasetId: datasetId
        })
    }
</script>